var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import styled from 'styled-components';
var StyledError = styled.small(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  display: none;\n  margin: 0.25rem ", " 0 ", ";\n"], ["\n  color: ", ";\n  display: none;\n  margin: 0.25rem ", " 0 ", ";\n"])), function (p) {
  return p.theme.danger;
}, function (p) {
  return p.theme.borderRadius;
}, function (p) {
  return p.theme.borderRadius;
});

var InputError = function InputError(_a) {
  var children = _a.children,
      props = __rest(_a, ["children"]);

  return React.createElement(StyledError, Object.assign({
    className: "input-error"
  }, props), children);
};

export default InputError;
var templateObject_1;